// extracted by mini-css-extract-plugin
export default {"bannerPic":"index_bannerPic_NlSm3","pageBottomBox":"index_pageBottomBox_u-gcp","pageBottomLogo":"index_pageBottomLogo_Vljs-","pageBottomButton":"index_pageBottomButton_FkPzN"};